import { matchPath } from 'react-router-dom';

/**
 * Acquisition / marketing surfaces: the homepage and the free funnel steps.
 * Brands flagged with brandMarketingDisabled (see utils/getBrand.jsx) send
 * every one of these to /login instead of rendering them.
 *
 * The paid funnel steps — checkout, payment, offer upsells and success — are
 * deliberately NOT listed, so anyone holding a live link or mid-purchase can
 * still finish and land on their account.
 */
const MARKETING_PATHS = [
  '/',
  '/home',
  '/:funnelId/landing',
  '/:funnelId/quiz/:questionNr',
  '/:funnelId/email',
  '/:funnelId/summary/:code',
];

/**
 * @param {string} pathname
 * @returns {boolean} true if pathname is one of the marketing surfaces above
 */
export const isMarketingPath = (pathname) =>
  MARKETING_PATHS.some((pattern) => matchPath(pattern, pathname) !== null);
